<template>
    <div class="c2-task-main" v-if="bodyShow">
        <h2>{{title}}</h2>
        <public-dialogue v-if="data.testid&&data.testid != 0" :testid="data.testid" :cid="$route.query.cid" :taskid="$route.query.id"></public-dialogue>
        <!--  -->
        <div v-for="(item,index) in list" :key="index" class="c2-task-group">
            <h3>{{item.label}}</h3>
            <textarea class="c2-textarea" @input="textareaChange(index,item.content,item.id,item.config.word)" v-model="item.content" :placeholder="item.config.placeholder" ></textarea>
            <span class="c2-word-limit">{{item.content?item.content.length:0}}/{{item.config.word}}</span>
        </div>
        <!-- 引入项目攻略入口 -->
        <task-strategy :cid="$route.query.cid" :pid="$route.query.pid"></task-strategy>
        <!-- submit -->
        <button :class="['c-submit',bool?'on':'']" @click="submithandle">提交</button>
    </div>
</template>

<script>
import { index, subtable } from "@/api/course"
import { getStorage, setStorage } from "@/utils/tools"
import { shareCon } from "@/utils/wxconfig"
import TaskStrategy from "@c/course/task-strategy"
export default {
    data() {
        return{
            bodyShow:false,
            title:'',
            list:[],
            userfield:[],
            bool:true,
            word_num:0,
            data:{},
        }
    },
    components:{
        TaskStrategy
    },
    methods:{
        //改变输入框时触发------- 下标、内容、id、字数长度
        textareaChange(index,content,id,word){
            this.$forceUpdate();
            if(content && content.length > word) {
                this.$set(this.list[index],'content',content.slice(0, word));
		        this.$toast(`最多只能输入${word}个字。/(ㄒoㄒ)/~~`);
		    }else{
		    	setStorage(this.$route.path, 'id'+id, content);
            }
            this.validationHandle();
        },
        pullData(){
            // loading
            this.$toast.loading({
                mask: true,
                message: "加载中..."
            });
            index({
                cid: this.$route.query.cid,
                cpid: this.$route.query.pid,
                cptid: this.$route.query.id
            })
            .then((data) => {
                this.$toast.clear();
                if(data.code===10002){
                    this.$toast(data.data.msg);
                    return
                }
                this.list = data.field;
                this.userfield = data.userfield;
                this.data = data;
                document.title = this.$route.query.name;
                this.title = data.title;
                this.validationHandle(true);
                this.bodyShow = true;
            })
        },
        validationHandle(bl){
            let b = true;
            if(this.list && this.list.length==0){
                this.bool = false;
                return
            }
            this.list.forEach((item,index)=>{
                // 判断是否是初始化
                if(bl){
                     // 判断是否已提交过数据
                    if(this.userfield && this.userfield.length>0){
                        this.userfield.forEach((item2,key)=>{
                            if(this.list[index].content){
                                return
                            }
                            if(item2.content && item2.field_id == item.id){
                                this.list[index].content = item2.content;
                            }
                        });
                        if(!this.list[index].content) {
                            this.list[index].content = '';
                        }
                    }else{
                        this.list[index].content = this.list[index].content?this.list[index].content:getStorage(this.$route.path, 'id'+item.id) || '';
                    }
                }
                // 判读是否有空
                if(!this.list[index].content || this.list[index].content==''){
                    b =false;
                }
            });
            this.bool = b;
        },
        submithandle(){
            if(this.bool){
                let arr = [];
                this.list.forEach((item,index)=>{
                    arr.push({
                        field_id:item.id,
                        content:item.content
                    });
                });
                subtable({
                    cid:this.$route.query.cid,
                    form_id:this.list[0].form_id,//引入form_id都是一样的，所以取一个就可以
                    field:JSON.stringify(arr)
                }).then((data)=>{
                    this.$toast({
                        duration: 1000,
                        message: '提交成功！',
                        onClose:()=>{
                            this.$router.push({
                                path:'/project_report',
                                query:{
                                    cid:this.$route.query.cid,
                                    cpid:this.$route.query.pid,
                                    taskid: this.$route.query.id
                                }
                            });
                        }
                    });
                });
            }
        }
    },
    created(){
        this.pullData();
        shareCon("course2",this);
    }
}
</script>

<style lang="scss" scope>
    .c2-task-main{
        padding: 40px 30px 80px;
        text-align: center;
        h2{
            font-weight: bold;
            font-size: 36px;
            color: #333333;
            text-align: center;
        }
        .c2-task-group{
            margin-top: 40px;
            position: relative;
            h3{
                text-align: left;
                font-size: 32px;
                color: #EA345C;
            }
            .c2-textarea{
                margin-top: 20px;
                height: 160px;
                border-radius: 8px;
                background-color: #fff;
                border: 0;
                width: 100%;
                padding: 22px 20px;
                font-size: 26px;
                resize:none;
                text-align: left;
            }
            .c2-word-limit{
                position: absolute;
                font-size: 18px;
                color: #999;
                bottom: 14px;
                right: 16px;
            }
        }
        .c-submit{
            width:174px;
            height:66px;
            background:#CCCCCC;
            border-radius:33px;
            font-size: 34px;
            color: #FFFFFF;
            border: 0;
            margin: 80px auto auto;
        }
        .c-submit.on{
            background-color: #EA345C;
        }
    }
</style>